import { getAuthAxiosBackend } from "@/helpers/axios"

class OwnershipTypesServices {
    get(id) {
        return getAuthAxiosBackend().get('OwnershipTypes/getOwnershipTypesById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('OwnershipTypes/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('OwnershipTypes/add', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('OwnershipTypes/update/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('OwnershipTypes/restore' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('OwnershipTypes/soft-delete/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('OwnershipTypes/delete/' + id.toString())
    }
}

export default new OwnershipTypesServices()
